import { salesforceChatEnvironmentVariables } from '@/constants'

let latestUserinfo = null;
let readyHandlerRegistered = false;

function setPrechatFields(userinfo) {
    if (
        window.embeddedservice_bootstrap &&
        window.embeddedservice_bootstrap.prechatAPI &&
        userinfo
    ) {
        window.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
    "AccountNumber": {
        "value": userinfo.AgentNumber || '',
        "isEditableByEndUser": true
    },
    "_firstName": {
        "value": userinfo.AgentFirstName || '',
        "isEditableByEndUser": true
    },
    "_lastName": {
        "value": userinfo.AgentLastName || '',
        "isEditableByEndUser": true
    },
    "_email": {
        "value": userinfo.email || '',
        "isEditableByEndUser": true
    }
});

    }
}

function registerReadyHandler() {
    if (readyHandlerRegistered) return;
    readyHandlerRegistered = true;

    window.addEventListener("onEmbeddedMessagingButtonCreated", () => {
        setPrechatFields(latestUserinfo);

        // Auto‑launch chat if API is available
        if (window.embeddedservice_bootstrap?.utilAPI?.launchChat) {
            window.embeddedservice_bootstrap.utilAPI.launchChat();
        }
    }, { once: true });
}

function initEmbeddedMessaging() {
    try {
        registerReadyHandler();

        window.embeddedservice_bootstrap.settings = window.embeddedservice_bootstrap.settings || {};
        window.embeddedservice_bootstrap.settings.language = 'en_US';
        window.embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true;

        window.embeddedservice_bootstrap.init(
            salesforceChatEnvironmentVariables.SALESFORCE_EMBEDDED_MESSAGING_ID,
            'Agency_Care_Desk_TFN',
            salesforceChatEnvironmentVariables.SALESFORCE_EMBEDDED_MESSAGING_ESWURL,
            {
                scrt2URL: salesforceChatEnvironmentVariables.SALESFORCE_EMBEDDED_MESSAGING_SCRT2URL
            }
        );
        window.embeddedservice_bootstrap._initialized = true;
    } catch (err) {
        console.error('Error loading Embedded Messaging: ', err);
    }
}

export default {
    openWebChat(userinfo) {
        latestUserinfo = userinfo;

        if (
            window.embeddedservice_bootstrap &&
            window.embeddedservice_bootstrap._initialized
        ) {
            setPrechatFields(latestUserinfo);
            window.embeddedservice_bootstrap?.utilAPI?.launchChat?.();

            return;
        }

        const script = document.createElement("script");
        script.src = salesforceChatEnvironmentVariables.SALESFORCE_EMBEDDED_MESSAGING_ASSETS;
        script.onload = () => {
            initEmbeddedMessaging();
        };
        script.onerror = (e) => {
            console.error('[WebChat] Failed to load Salesforce script', e);
        };
        document.head.appendChild(script);
    }
};